// extracted by mini-css-extract-plugin
export default {"card":"PS-z","defaultCard":"QS-z","cardDetails":"RS-z","cardActions":"SS-z","separator":"TS-z"};